// src/packages/care/prediction/adapters/registry.ts
//
// Ordered list of fertile-window models, most-specific first. The orchestrator (Step 5) walks
// this in order and selects the first eligible model for display; all eligible models can also
// be run side-by-side for Phase-4 baseline-vs-candidate validation.
//
// Future specialist adapters (LH, BBT, cervical mucus, wearable) will be appended here once
// their backend schema exists (issue #1953).

import { personalizedCycleModel } from "./personalizedCycleModel";
import { calendarCycleModel } from "./calendarCycleModel";
import type { FertileWindowModel } from "./types";

/** Priority order: prefer the personalized Bayesian model; fall back to the calendar baseline. */
export const FERTILE_WINDOW_MODELS: readonly FertileWindowModel[] = [
  personalizedCycleModel,
  calendarCycleModel,
];
